import React,{useContext} from 'react'
import { useNavigate } from 'react-router-dom'
import {
   Box,
   Button,
   Card,
   CardContent,
   TextField,
   InputAdornment,
   SvgIcon
   // Menu,
   // MenuItem
} from '@material-ui/core'
import { Search as SearchIcon } from 'react-feather'
import { ShoppingCartContext } from '../../contexts/ShoppingCart'

const HoseListToolbar = props => {
   // const [anchorCustomHoseAssemblies, setAnchorCustomHoseAssemblies] = useState(null)
   // const [openCustomHoseAssemblies, setOpenCustomHoseAssemblies] = useState(false)
   // const [anchorHoseTubings, setAnchorHoseTubings] = useState(null)
   // const [openHoseTubings, setOpenHoseTubings] = useState(false)
   // const [anchorHoseFittings, setAnchorHoseFittings] = useState(null)
   // const [openHoseFittings, setOpenHoseFittings] = useState(false)
   const navigate = useNavigate()

   // const handleCustomHoseAssemblies = event => {
   //    setOpenCustomHoseAssemblies(true)
   //    setAnchorCustomHoseAssemblies(event.currentTarget)
   // }

   // const handleCustomHoseAssembliesClose = () => setOpenCustomHoseAssemblies(false)

   // const handleHoseTubings = event => {
   //    setOpenHoseTubings(true)
   //    setAnchorHoseTubings(event.currentTarget)
   // }

   // const handleHoseTubingsClose = () => setOpenHoseTubings(false)

   // const handleHoseFittings = event => {
   //    setOpenHoseFittings(true)
   //    setAnchorHoseFittings(event.currentTarget)
   // }

   // const handleHoseFittingsClose = () => setOpenHoseFittings(false)
   const { setSearchAdmin, searchAdmin } = useContext(ShoppingCartContext)
   const navigateToAdd = () => navigate('/app/add-admin')

   return (
      <>
         <Box {...props}>
            <Box
               sx={{
                  display: 'flex',
                  justifyContent: 'space-between'
               }}
            >
               <Box>
                  {/* <Button
                     aria-owns={openCustomHoseAssemblies ? 'custom-hose-assemblies' : null}
                     aria-haspopup='true'
                     onClick={handleCustomHoseAssemblies}
                     onMouseOver={handleCustomHoseAssemblies}
                  >
                     Custom Hose Assemblies
                  </Button>
                  <Button
                     aria-owns={openHoseTubings ? 'hose-tubings' : null}
                     aria-haspopup='true'
                     onClick={handleHoseTubings}
                     onMouseOver={handleHoseTubings}
                  >
                     Hose &amp; Tubings
                  </Button>
                  <Button
                     aria-owns={openHoseFittings ? 'hose-fittings' : null}
                     aria-haspopup='true'
                     onClick={handleHoseFittings}
                     onMouseOver={handleHoseFittings}
                  >
                     Hose Fittings
                  </Button>*/}
               </Box>
               {localStorage.user_type !== 'customer' && (
                  <Box>
                     <Button>Import</Button>
                     <Button sx={{ mx: 1 }}>Export</Button>
                     <Button color='primary' variant='contained' onClick={navigateToAdd}>
                        Add Admin
                     </Button>
                  </Box>
               )}
            </Box>
            <Box sx={{ mt: 3 }}>
               <Card>
                  <CardContent>
                     <Box sx={{ maxWidth: 500 }}>
                        <TextField
                           fullWidth
                           InputProps={{
                              style: { borderColor: '#8d8d8d !important', borderWidth: '1px' },
                              startAdornment: (
                                 <InputAdornment position='start'>
                                    <SvgIcon fontSize='small' color='error'>
                                       <SearchIcon />
                                    </SvgIcon>
                                 </InputAdornment>
                              )
                           }}
                           placeholder='Search admin'
                           variant='outlined'
                           value={searchAdmin}
                           onChange={e => {
                              setSearchAdmin(e.target.value)
                           }}
                        />
                     </Box>
                  </CardContent>
               </Card>
            </Box>
         </Box>
         {/* <Menu
            id='custom-hose-assemblies'
            className='simple-menu'
            anchorEl={anchorCustomHoseAssemblies}
            open={openCustomHoseAssemblies}
            onClose={handleCustomHoseAssembliesClose}
         >
            <MenuItem onClick={handleCustomHoseAssembliesClose}>Steel</MenuItem>
            <MenuItem onClick={handleCustomHoseAssembliesClose}>Brass</MenuItem>
            <MenuItem onClick={handleCustomHoseAssembliesClose}>British &amp; Metric</MenuItem>
            <MenuItem onClick={handleCustomHoseAssembliesClose}>Banjo Fittings</MenuItem>
         </Menu>
         <Menu
            id='hose-tubings'
            className='simple-menu'
            anchorEl={anchorHoseTubings}
            open={openHoseTubings}
            onClose={handleHoseTubingsClose}
         >
            <MenuItem onClick={handleHoseTubingsClose}>ISO 16028 Skidsteer Couplers</MenuItem>
            <MenuItem onClick={handleHoseTubingsClose}>ISO 5675 Agricultural Couplers</MenuItem>
            <MenuItem onClick={handleHoseTubingsClose}>4100 Series Wet-Line Couplers</MenuItem>
            <MenuItem onClick={handleHoseTubingsClose}>
               ISO 7241-1 Series-A Couplers (600 Series)
            </MenuItem>
            <MenuItem onClick={handleHoseTubingsClose}>
               ISO 7241-1 Series-B Couplers (700 Series)
            </MenuItem>
         </Menu>
         <Menu
            id='hose-fittings'
            className='simple-menu'
            anchorEl={anchorHoseFittings}
            open={openHoseFittings}
            onClose={handleHoseFittingsClose}
         >
            <MenuItem onClick={handleHoseFittingsClose}>Hose Crimpers &amp; Tools</MenuItem>
            <MenuItem onClick={handleHoseFittingsClose}>Pressure Gauges</MenuItem>
            <MenuItem onClick={handleHoseFittingsClose}>Ball Valves</MenuItem>
            <MenuItem onClick={handleHoseFittingsClose}>O-Rings &amp; Seals</MenuItem>
            <MenuItem onClick={handleHoseFittingsClose}>Closeout &amp; Overstock Deals</MenuItem>
            <MenuItem onClick={handleHoseFittingsClose}>Wormgear Clamps</MenuItem>
         </Menu> */}
      </>
   )
}

export default HoseListToolbar
